import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import axios from "axios";
import { ESTransport } from "./ESTransport";

var defaults = require("lodash/defaults");

export var AxiosESTransport =
/*#__PURE__*/
function (_ESTransport) {
  _inherits(AxiosESTransport, _ESTransport);

  function AxiosESTransport(host) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, AxiosESTransport);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AxiosESTransport).call(this));
    _this.host = host;
    _this.options = defaults(options, {
      headers: {},
      searchUrlPath: "/_search",
      timeout: AxiosESTransport.timeout
    });
    var credentials = AxiosESTransport.parseCredentials(_this.options);
    var config = defaults(credentials, {
      baseURL: _this.host,
      timeout: _this.options.timeout,
      headers: _this.options.headers
    });
    _this.axios = axios.create(config);
    return _this;
  }

  _createClass(AxiosESTransport, [{
    key: "search",
    value: function search(query) {
      return this.axios.post(this.options.searchUrlPath, query).then(this.getData);
    }
  }, {
    key: "getData",
    value: function getData(response) {
      return response.data;
    }
  }], [{
    key: "parseCredentials",
    value: function parseCredentials(options) {
      var credentials = {};

      if (options.basicAuth !== undefined) {
        var parsed = options.basicAuth.split(":");
        var auth = {
          username: parsed[0],
          password: parsed[1]
        };
        credentials['auth'] = auth;
      }

      if (options.withCredentials) {
        credentials['withCredentials'] = true;
      }

      return credentials;
    }
  }]);

  return AxiosESTransport;
}(ESTransport);
AxiosESTransport.timeout = 5000;